import type { MonospacePrimitiveFieldMeta, MonospaceSerializedPrimitiveField } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

interface StudioPrimitiveField extends MonospaceSerializedPrimitiveField {
	isStudioOnly?: boolean;
}

export const PrimitiveField = withItemType<StudioPrimitiveField>().defineCollection({
	name: 'MonospacePrimitiveField',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'dbName', 'apiName', 'type', 'defaultValue', 'isNullable', 'isList', 'queryCapabilities', 'collectionId'],
	},
});

export const PrimitiveFieldMeta = withItemType<MonospacePrimitiveFieldMeta>().defineCollection({
	name: 'MonospacePrimitiveFieldMeta',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.fieldId,
	meta: {
		defaultFields: ['fieldId', 'displayName', 'description', 'typeTemplateId', 'typeOptions', 'inputId', 'inputOptions', 'displayId', 'displayOptions', 'isHidden', 'sort'],
		connect: {
			fieldId: ['field', 'id'],
		},
	},
});
